import React from "react";
import { Link } from "react-router-dom";
import {useAuth} from "../hooks/useAuth";
import "../styles/Navbar.scss";

function Navbar() {

    let auth = useAuth();

    return (
        <div className="navbar">
            <div className="brand">
                <h1 className="header">
                    <Link to="/">Anvil</Link>
                </h1>
                <div className="sublabel">Admin Panel</div>
            </div>
            {
                auth.user && auth.permissionLevel == 100 ? (
                    <div className="nav">
                        <Link className="link" to="/">Auth Logs</Link>
                        <Link className="link" to="/users">Users</Link>
                        <Link className="link" to="/ip">IP Bans</Link>
                        <Link className="link" to="/invites">Invites</Link>
                        <Link className="link" to="/dlls">DLLs</Link>
                        <Link className="link" to="/luas">Lua Management</Link>
                        <Link className="link" to="/server">Server Dashboard</Link>
                     </div>
                ) : 
                auth.user && auth.permissionLevel == 1 ? (
                    <div className="nav">
                        <Link className="link" to="/server">Server Dashboard</Link>
                     </div>
                ) : ("")
            }
           
        </div>
    );
}

export default Navbar;
